import React from "react";

import SpacerAndDivider from "../spacer-and-divider/SpacerAndDivider";
import { SpacerAndDividerEditorContainer } from "./styles";
import { useSpacerAndDividerStore } from "../../../../stores/use-spacer-and-divider-store";

const SpacerAndDividerEditor = () => {
  const data = useSpacerAndDividerStore((state) => state.data);

  return (
    <SpacerAndDividerEditorContainer justifyContent={data.textAlignment}>
      <SpacerAndDivider data={data} />
    </SpacerAndDividerEditorContainer>
  );
};

export default SpacerAndDividerEditor;
